import { useState, useEffect, useCallback } from 'react';

let globalDeferred = null;

const listeners = new Set();

function notify() {
  listeners.forEach((fn) => fn());
}

// Single global listener for beforeinstallprompt
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    globalDeferred = e;
    notify();
  });
  window.addEventListener('appinstalled', () => {
    globalDeferred = null;
    notify();
  });
}

export function usePWAInstall() {
  const [, forceUpdate] = useState(0);
  const [installed, setInstalled] = useState(
    typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(display-mode: standalone)').matches
  );

  useEffect(() => {
    const update = () => forceUpdate((n) => n + 1);
    listeners.add(update);
    return () => listeners.delete(update);
  }, []);

  useEffect(() => {
    const handler = () => setInstalled(true);
    window.addEventListener('appinstalled', handler);
    return () => window.removeEventListener('appinstalled', handler);
  }, []);

  const triggerInstall = useCallback(() => {
    if (globalDeferred) {
      globalDeferred.prompt();
      globalDeferred.userChoice.then(() => {
        globalDeferred = null;
        notify();
        // Whether the user accepted or dismissed the native prompt, take them into
        // the delivery app so they never get stranded on the marketing page.
        window.location.replace('/app/index.html');
      });
      return;
    }
    // No native install prompt available (already installed, iOS, desktop, or the
    // browser didn't offer it). Never dead-end the user — open the actual web app
    // so they always reach the delivery experience. Use replace() (not href) so the
    // marketing page is dropped from history: once inside the app, the device/browser
    // back button no longer bounces the user back out to the marketing site.
    window.location.replace('/app/index.html');
  }, []);

  return { installed, triggerInstall };
}
